<template>

<section>
  <HomeSectionTitle>
    <template v-slot:title>
      for Security
    </template>
    <template v-slot:copy>
      산업 현장의 안전사고 검출, 신원 확인, 장비 검사 등에 활용할 수 있는 APIs입니다.
    </template>
  </HomeSectionTitle>
  <HomeCards :cards="cards" class="cards-images"/>
</section>

</template>

<script>
import HomeSectionTitle from './HomeSectionTitle'
import HomeCards from './HomeCards'
import {getSecurityItems} from '@/tree'
export default {
  data() {
    return {
      cards: getSecurityItems()
    }
  },
  components: {
    HomeSectionTitle,
    HomeCards,
  }
}

</script>

<style lang="scss" scoped>
.cards-images {
  margin-top: 68px;
  margin-bottom: 100px;
}
</style>